import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ArrayUtils } from "~app/common/utils/array-utils";
import {
    IHandelssortimentSearchParamsModel,
    ISearchHandelssortimentModel,
    UpdateMinaHandelssortimentCommand
} from "~app/features/forsaljning/handelssortiment/handelssortiment.models";

@Injectable({
    providedIn: "root"
})
export class MinaHandelssortimentService {
    private readonly apiClient = inject(ApiClientService);

    searchForHandelssortiment(handelssortimentSearchParams: IHandelssortimentSearchParamsModel): Observable<ISearchHandelssortimentModel[]> {
        return this.apiClient.get<ISearchHandelssortimentModel[]>("handelssortiment", false, handelssortimentSearchParams);
    }

    getMinaHandelssortiment(allowCache: boolean): Observable<ISearchHandelssortimentModel[]> {
        return this.apiClient.get<ISearchHandelssortimentModel[]>(`mina/handelssortiment`);
    }

    saveMinaHandelssortiment(command: UpdateMinaHandelssortimentCommand): Observable<any> {
        return this.apiClient.put(`Mina/Handelssortiment/Update`, command);
    }

    orderBy(value1: any, value2: any, desc = false): number {
        return ArrayUtils.orderBy(value1, value2, desc);
    }
}
